import React from 'react';
const DataLoader=(props)=>{
    return(
      
        <div className="MainLoader"><i className="fas fa-spin"><img src={require("../../Investment/Images/SmcLoader.png")} /></i></div>
    )
}
export default DataLoader;